import { defineComponent as _defineComponent } from 'vue'
import Vue from 'vue'
  import { computed, onMounted, nextTick } from 'vue'

  import { useRoute } from 'vue-router/composables'
  import useCourse from '@/composables/useCourse'
  import useI18n from '@/composables/useI18n'
  import useEditor from '@/composables/useEditor'
  import useCommonMixin from '@/composables/useCommonMixin'

  import CourseApi from '@/services/api/CourseApi'

  import { UserModule } from '@/store/modules/user'

  import hljs from 'highlight.js'
  import eventBus from '@/main'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'HTMLRenderer',
  props: {
    html: {
      type: String,
      required: true,
    },
    increasePadding: {
      type: Boolean,
      default: false,
    },
    linkTarget: {
      type: String,
      default: '_self',
    },
    linkPattern: {
      type: String,
      default: '.*.ketchup.academy/courses',
    },
    addImageShadow: {
      type: Boolean,
      default: false,
    },
    contentClamped: {
      type: Boolean,
      default: false,
    },
    formatContent: {
      type: Boolean,
      default: false,
    },
    searchTerm: String,
    skipGlossaryCheck: {
      type: Boolean,
      default: false,
    },
  },
  setup(__props) {

const props = __props;

  

  const route = useRoute()
  const { decodeAndParseSource } = useEditor(route)
  const { formatPhrase, windowOpenProxyCheck } = useCommonMixin()
  const { openLessonModal, onModulePage, onLessonPage } = useCourse()
  const { translateString } = useI18n()

  const docId = `doc-id-${Math.floor(Math.random() * 1000000000).toString()}`

  const content = computed((): string =>
    props.formatContent
      ? formatPhrase(decodeAndParseSource(props.html) as string, props.searchTerm)
      : (decodeAndParseSource(props.html) as string),
  )

  const sourceContent = computed(() => {
    if (props.skipGlossaryCheck || !(onLessonPage.value || onModulePage.value)) return content.value
    const glossaryItems = UserModule.glossaryItems
    if (glossaryItems?.length === 0) {
      return content.value
    }
    let replacedContent = ''
    let splitContent = content.value.split(/\n/)

    glossaryItems?.forEach((item) => {
      replacedContent = splitContent
        .map((p) => {
          const regexMatch = new RegExp(`\\b(${item.text})\\b`, 'g')
          return p.replace(
            regexMatch,
            `<span class='glossary-item-wrapper'>
                 <span class='glossary-item'>
                    <span>${item.text}</span>
                 </span>
              </span>`,
          )
        })
        .join('\n')
      splitContent = replacedContent.split(/\n/)
    })
    return replacedContent
  })

  const showLessonModal = (link: string) => {
    const linkProps = link.slice(link.indexOf('courses')).split('/')
    eventBus.$emit('turn-on-loader')
    const lessonId = linkProps.slice(linkProps.indexOf('lesson'))[1] ?? ''
    const courseId = linkProps[1] ?? ''
    const moduleId = linkProps.slice(linkProps.indexOf('module'))[1] ?? ''

    CourseApi.getLesson(courseId, moduleId, lessonId)
      .then((lesson) => {
        openLessonModal({
          lessonId,
          courseId,
          moduleId,
          lessonToRender: lesson,
        })
      })
      .catch(() => {
        eventBus.$toasted.error(translateString('courses.couldNotFetchLesson'))
      })
      .finally(() => eventBus.$emit('turn-off-loader'))
  }

  const handleClick = (e: MouseEvent) => {
    const link = (e.target as HTMLElement).closest('a') as HTMLAnchorElement | null
    if (!link) return

    if (props.linkPattern && link.href.match(props.linkPattern)?.length) {
      if (link.href.match(/lesson/)) {
        e.preventDefault()
        showLessonModal(link.href)
      }
    } else {
      e.preventDefault()
      windowOpenProxyCheck(link.href, props.linkTarget)
    }
  }

  const setHoverEventListenerToGlossaryItems = (rendererDiv: HTMLDivElement) => {
    const glossaryElements = rendererDiv?.getElementsByClassName('glossary-item') || []
    for (let index = 0; index < glossaryElements.length; index++) {
      const element = glossaryElements.item(index)
      if (element) {
        element.addEventListener('mouseenter', () => {
          const glossaryText = element.children[0].innerHTML
          const glossaryItem = UserModule.glossaryItems?.find((item) => item.text === glossaryText)
          const tooltipComponent = Vue.extend({
            template: `<span class='glossary-item-wrapper'>
                              <VPopover popover-inner-class='glossary-popover'>
                                <span class='glossary-item'>
                                  <span>${glossaryText}</span>
                                </span>
                                <template #popover>
                                  <h6 class='ketch-opacity-60 ketch-mb-c10'>${translateString('briefDescription')}</h6>
                                  <h6>${glossaryItem?.description}</h6>
                                </template>
                              </VPopover>
                           </span>`,
          })
          const tooltipComponentInstance = new tooltipComponent()
          tooltipComponentInstance.$mount(element)
        })
      }
    }
  }

  onMounted(() => {
    nextTick(() => {
      const rendererDiv = document.getElementById(docId) as HTMLDivElement
      if (rendererDiv) {
        setHoverEventListenerToGlossaryItems(rendererDiv)
        hljs.highlightAll()
      }
    })
  })

return { __sfc: true,props, route, decodeAndParseSource, formatPhrase, windowOpenProxyCheck, openLessonModal, onModulePage, onLessonPage, translateString, docId, content, sourceContent, showLessonModal, handleClick, setHoverEventListenerToGlossaryItems, Vue, computed, onMounted, nextTick, useRoute, useCourse, useI18n, useEditor, useCommonMixin, CourseApi, UserModule, hljs, eventBus }
}

})